import React from 'react';

function Model({ imageUrl, label, fontSize }) {
	return (
		<span className="outlined model" style={{ display: 'flex', alignItems: 'center' }}>
			{imageUrl && <img src={imageUrl} alt={label} />}
			<span style={{ fontWeight: 600 }}>{label}</span>
		</span>
	);
}

export default Model;
